var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16.8,
    viewBox: "0 0 16 16.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 9.426a2.08 2.08 0 1 0 0 -4.16 2.08 2.08 0 0 0 0 4.16Z",
    stroke: "#1D2023",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.413 6.132C3.726 0.358 12.28 0.365 13.586 6.138c0.766 3.386 -1.34 6.254 -3.186 8.026a3.464 3.464 0 0 1 -4.807 0c-1.84 -1.773 -3.946 -4.646 -3.18 -8.033Z",
    stroke: "#1D2023",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.7f3806365ac9dc88edf13c305a6cb4be.svg";
export { ForwardRef as ReactComponent };